import YandexMapLoader from "../map/YandexMap";

$(document).ready(function () {
	let $document = $(document),
		$formCart = $("#form-cart")
	;

	$document.on('change', '#order_city', function () {
		let val = $(this).val();

		if (!val) {
			$formCart.find('.user-city-id').hide();
			$formCart.find(".user-city").show();
			$formCart.find(".user-city input").focus();
		} else {
			$formCart.find(".user-city").val('').hide();
		}

		$formCart.find('[name=user_address_cdek]').val('');
	});

	$formCart.find('[name=user_city]').blur(function () {
		let val = $.trim(String($(this).val()).toLowerCase());

		if (!val) {
			$formCart.find('.user-city-id option').first().prop('selected', true);
			$formCart.find('.user-city-id').show();
			$formCart.find('.user-city').hide();
			$formCart.find('[name=user_address_cdek]').val('');

			VegasCatalog.Cart.updateTotalAll();
		}

		let $orderCity = $formCart.find('#order_city');
		$orderCity.find('option').each(function (i, e) {
			let curId = $(e).val();
			let curValue = $.trim(String($(e).text()).toLowerCase());

			if (val === curValue) {
				$orderCity.val(curId);
				$formCart.find('.user-city-id').show();
				$formCart.find('.user-city').hide();

				return;
			}
		});
	});

	let $userAddressCdek = $("#user_address_cdek");
	if ($userAddressCdek.length) {
		$userAddressCdek.on('change', function () {
			setTimeout(() => {
				VegasCatalog.Cart.updateTotalAll();
			}, 100);
		});

		new YandexMapLoader().load(() => {
			ymaps.ready(function () {
				let suggestView = new ymaps.SuggestView("user_address_cdek", {
					provider: {
						suggest: (function (request, options) {
							let city = $formCart.find('#order_user_city').val();
							if (!city) city = $formCart.find('#order_city option:selected').text();
							let search = [
								city, request
							].join(', ');

							return ymaps.suggest(search);
						})
					}
				});

				suggestView.events.add('select', function (e) {
					$userAddressCdek.trigger('change');
				});
			});
		})
	}
})
